'use strict';

import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';

class ErrorPopupInner extends React.Component {

  state = {
    mounted: false,
  }

  componentDidMount = () => {
    this.setState({ mounted: true });
  }

  closeErrorPopup = () => {
    this.setState({ mounted: false });
    setTimeout(() => {
      this.props.popup_container.remove();
    }, 500);
  }

  render() {
    return (
      <CSSTransition in={this.state.mounted} timeout={500} classNames="confirmation-box">
        <div id="confirmation-box" className="confirmation-box">
          <div className="confirmation-box__inner">
            <div className="confirmation-box__message">{this.props.message}</div>
            <div className="confirmation-box__buttons">
              <div className="confirmation-box__button" onClick={this.closeErrorPopup}>OK</div>
            </div>
          </div>
        </div>
      </CSSTransition>
    );
  }
}

export default function activateErrorPopup(message) {

  var popup_container = document.createElement("div");
  document.body.appendChild(popup_container);

  ReactDOM.render(
    <ErrorPopupInner
      popup_container={popup_container}
      message={message}
    />, popup_container
  );
}